import { mockRaffles } from "data/mockData";
import React from "react";
import { FaShieldAlt, FaTicketAlt, FaTrophy } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { config } from "config";

const gold = "#F5A623";
const goldDark = "#C97A0B";

const GlobalKeyframes = () => (
  <style>{`
    @keyframes float {
      0%,100% { transform: translateY(0); }
      50% { transform: translateY(-10px); }
    }
    .float {
      animation: float 4s ease-in-out infinite;
    }
  `}</style>
);

interface HeroSliderProps {
  onHowItWorksClick?: () => void;
}

export const HeroSlider: React.FC<HeroSliderProps> = ({
  onHowItWorksClick,
}) => {
  const featured = mockRaffles.find((r) => r.featured);

  return (
    <>
      <GlobalKeyframes />

      <section
        className="position-relative py-5 px-3"
        style={{
          background:
            "linear-gradient(160deg, #fff 0%, #FFF8EC 60%, #FFF3D6 100%)",
        }}
      >
        <div className="container">
          <div className="row align-items-center g-5">
            {/* LEFT */}
            <div className="col-lg-6">
              <p
                className="text-uppercase fw-bold mb-2"
                style={{
                  fontSize: "0.9rem",
                  letterSpacing: "0.15em",
                  color: gold,
                }}
              >
                Plataforma #1 de Rifas Online
              </p>

              <h1
                className="fw-bold mb-3"
                style={{
                  fontSize: "clamp(2rem, 5vw, 2.6rem)",
                  lineHeight: 1.15,
                  letterSpacing: "-0.02em",
                }}
              >
                Concorra a{" "}
                <span style={{ color: gold }}>prêmios incríveis</span> pagando
                muito pouco.
              </h1>

              <p className="text-muted mb-4">
                Compre seus tickets com segurança, acompanhe o progresso da
                Campanha com total transparência e cruze os dedos.
                <br />
                Processo simples, justo e confiável, os sorteios são baseados na{" "}
                <strong>Loteria Federal</strong>.
              </p>

              <div className="d-flex flex-column flex-sm-row gap-3">
                <Link
                  to="/campaign/default/list"
                  className="btn fw-bold text-white"
                  style={{
                    background: `linear-gradient(135deg, ${gold}, ${goldDark})`,
                    borderRadius: 50,
                    padding: "0.8rem 1.8rem",
                    border: "none",
                  }}
                >
                  Ver Campanhas
                </Link>

                <Link
                  to="/#como-funciona"
                  className="btn fw-bold"
                  style={{
                    borderRadius: 50,
                    padding: "0.8rem 1.8rem",
                    border: `1.5px solid ${gold}`,
                    color: gold,
                    background: "transparent",
                  }}
                  onClick={onHowItWorksClick}
                >
                  Como funciona?
                </Link>
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-lg-6 position-relative d-flex justify-content-center">
              {featured && (
                <div
                  className="position-relative float"
                  style={{
                    width: "100%",
                    maxWidth: 380,
                    borderRadius: 24,
                    background: "#fff",
                    boxShadow: "0 30px 80px rgba(0,0,0,0.18)",
                    overflow: "hidden",
                    zIndex: 2,
                  }}
                >
                  <img
                    src={featured.imageUrl}
                    alt={featured.title}
                    style={{
                      width: "100%",
                      height: 220,
                      objectFit: "cover",
                    }}
                  />

                  <div style={{ padding: "1.2rem" }}>
                    <span
                      style={{
                        background: "rgba(245,166,35,0.1)",
                        color: goldDark,
                        borderRadius: 50,
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        padding: "0.3rem 0.7rem",
                        display: "inline-block",
                        marginBottom: "0.5rem",
                      }}
                    >
                      {featured.badge}
                    </span>

                    <h6 className="fw-bold">{featured.title}</h6>

                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <span
                        style={{
                          fontWeight: 800,
                          color: goldDark,
                        }}
                      >
                        R$ {featured.ticketPrice.toFixed(2).replace(".", ",")}
                        <small className="text-muted"> / ticket</small>
                      </span>

                      {/* <button
                        className="btn text-white"
                        style={{
                          background: `linear-gradient(135deg, ${gold}, ${goldDark})`,
                          borderRadius: 50,
                          padding: "0.4rem 1rem",
                          border: "none",
                          fontSize: "0.8rem",
                        }}
                      >
                        Participar
                      </button> */}
                    </div>
                  </div>
                </div>
              )}

              {/* MINI CARD - TROPHY */}
              <div
                className="position-absolute d-none d-sm-flex align-items-center gap-2"
                style={{
                  top: 20,
                  left: -0,
                  background: "#fff",
                  borderRadius: 14,
                  padding: "0.6rem 1rem",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                  zIndex: 3,
                }}
              >
                <FaTrophy color="#ffc107" className="fs-4" />
                <div style={{ fontSize: "0.75rem" }}>
                  <strong>iPhone 17 Pro Max 256GB</strong>
                  <div className="text-muted">Compre agora!</div>
                </div>
              </div>

              {/* MINI CARD - SHIELD */}
              <div
                className="position-absolute d-none d-md-flex align-items-center gap-2"
                style={{
                  bottom: 50,
                  right: 10,
                  background: "#fff",
                  borderRadius: 14,
                  padding: "0.6rem 1rem",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                  zIndex: 3,
                }}
              >
                <FaShieldAlt color="#198754" className="fs-4" />
                <div style={{ fontSize: "0.75rem" }}>
                  <strong>Transparência</strong>
                  <div className="text-muted">Resultado Auditável</div>
                </div>
              </div>
            </div>
          </div>

          {/* STATS */}
          <div
            className="row text-center mt-5 g-0 overflow-hidden"
            style={{
              background: "#fff",
              borderRadius: 22,
              boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
            }}
          >
            {/* Benefícios */}
            <div className="col-6 col-md-3 py-4 px-3 border-end">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                style={{
                  width: 58,
                  height: 58,
                  background: "rgba(255, 159, 10, 0.10)",
                }}
              >
                <i
                  className="bi bi-lightning-charge-fill"
                  style={{ color: gold, fontSize: "1.45rem" }}
                />
              </div>

              <h4 className="mb-1" style={{ color: gold, fontWeight: 800 }}>
                0 Burocracia
              </h4>

              <small className="text-muted">Processo simples</small>
            </div>

            <div className="col-6 col-md-3 py-4 px-3 border-end">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                style={{
                  width: 58,
                  height: 58,
                  background: "rgba(255, 159, 10, 0.10)",
                }}
              >
                <i
                  className="bi bi-globe2"
                  style={{ color: gold, fontSize: "1.45rem" }}
                />
              </div>

              <h4 className="mb-1" style={{ color: gold, fontWeight: 800 }}>
                100% Online
              </h4>

              <small className="text-muted">Do início ao fim</small>
            </div>

            <div className="col-6 col-md-3 py-4 px-3 border-end">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                style={{
                  width: 58,
                  height: 58,
                  background: "rgba(255, 159, 10, 0.10)",
                }}
              >
                <i
                  className="bi bi-activity"
                  style={{ color: gold, fontSize: "1.45rem" }}
                />
              </div>

              <h4 className="mb-1" style={{ color: gold, fontWeight: 800 }}>
                Tempo Real
              </h4>

              <small className="text-muted">Acompanhe tudo</small>
            </div>

            <div className="col-6 col-md-3 py-4 px-3">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                style={{
                  width: 58,
                  height: 58,
                  background: "rgba(255, 159, 10, 0.10)",
                }}
              >
                <i
                  className="bi bi-shield-check"
                  style={{ color: gold, fontSize: "1.45rem" }}
                />
              </div>

              <h4 className="mb-1" style={{ color: gold, fontWeight: 800 }}>
                100%
              </h4>

              <small className="text-muted">Transparência</small>
            </div>

            {/* CTA */}
            <div className="col-12 border-top">
              <div className="row align-items-center g-0">
                {/* Texto */}
                <div className="col-md-7 text-start p-4">
                  <div className="d-flex align-items-start gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                      style={{
                        width: 58,
                        height: 58,
                        background: "rgba(255, 159, 10, 0.10)",
                      }}
                    >
                      <i
                        className="bi bi-ticket-perforated"
                        style={{ color: gold, fontSize: "1.6rem" }}
                      />
                    </div>

                    <div>
                      <h4 className="fw-bold mb-1" style={{ color: "#1f2d3d" }}>
                        Pronto para começar?
                      </h4>

                      <p className="text-muted mb-3">
                        Crie sua campanha e comece a vender seus tickets em
                        poucos minutos.
                      </p>

                      <div className="d-flex flex-wrap gap-3 small text-muted">
                        <span>
                          <i
                            className="bi bi-check-circle-fill me-1"
                            style={{ color: gold }}
                          />
                          É rápido
                        </span>

                        <span>
                          <i
                            className="bi bi-check-circle-fill me-1"
                            style={{ color: gold }}
                          />
                          100% online
                        </span>

                        <span>
                          <i
                            className="bi bi-check-circle-fill me-1"
                            style={{ color: gold }}
                          />
                          Sem burocracia
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Botão */}
                <div className="col-md-5 p-4 border-start">
                  <button
                    type="button"
                    className="btn w-100 fw-bold rounded-pill py-3"
                    style={{
                      background: gold,
                      borderColor: gold,
                      color: "#1f2d3d",
                      boxShadow: "0 8px 22px rgba(255, 159, 10, 0.24)",
                      fontSize: "1rem",
                    }}
                    onClick={() => {
                      window.open(`${config.urls.panel}`, "_blank");
                    }}
                  >
                    <FaTicketAlt className="fs-5 me-2" />
                    Quero criar a minha rifa
                    <FaArrowRight className="ms-2" />
                  </button>

                  <small className="d-block text-muted mt-2">
                    <i className="bi bi-lock-fill me-1" />
                    Seus dados ficam protegidos durante todo o processo.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
